import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { UserInterface } from 'src/app/interfaces/user';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(public auth: AuthService, public router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.auth.userSubject.pipe(
      take(1),
      map((user: UserInterface | null) => {
        const currentUrl = state.url;

        if (!user) {
          return this.router.parseUrl('/login');
        }

        return this.validateAccess(user, currentUrl);
      })
    );
  }

  private validateAccess(user: UserInterface, url: string): boolean | UrlTree {
    const status = user.tenant.tenantStatus;
    const isSupplier = user.tenant.companyType === 'SUPPLIER';

    switch (status) {
      case 'NEW':
        if (url !== '/configuracao-inicial') {
          return this.router.parseUrl('/configuracao-inicial');
        }
        return true;

      case 'VALIDATING':
      case 'BLOCKED':
      case 'OVERDUE':
        return this.handleRestrictedStatus(user, url);

      case 'PENDING':
        if (isSupplier && url === '/cotacoes') {
          return this.router.parseUrl('/dashboard');
        }
        return true;

      case 'ENABLED':
        if (isSupplier && url === '/cotacoes') {
          return this.router.parseUrl('/dashboard');
        }
        return true;

      default:
        return true;
    }
  }

  private handleRestrictedStatus(
    user: UserInterface,
    url: string
  ): boolean | UrlTree {
    const isSupplier = user.tenant.companyType === 'SUPPLIER';
    if (!isSupplier) {
      if (url !== '/validacao') {
        return this.router.parseUrl('/validacao');
      }
      return true;
    }

    if (url === '/cotacoes' || url === '/validacao') {
      return this.router.parseUrl('/dashboard');
    }

    return true;
  }
}
